import { TableRow, TableCell, CircularProgress, Checkbox, Skeleton, Stack, TextField, Typography, Button } from "@mui/material";
import { useState, useRef, useEffect } from "react";
import { ResidentDto } from "../../dtos/ResidentDto";
import { VillageDto } from "../../dtos/VillageDto";
import { formatDateTime, getOneSecondBeforeMidnight, getTomorrow, sleep } from "../../utils";
import TimerOffIcon from '@mui/icons-material/TimerOff';


type UpdateCardholderProps = {

    attribute: string,
    expiry: string | undefined,
    isActive: boolean,
    resident: ResidentDto,
    securityRoleIds: string[ ],
    title: string,
    village: VillageDto
    addAttribute( attribute: string, employeeId: string, securityRoleIds: string[ ], until: string | undefined, villageCode: string ): Promise<boolean>,
    removeAttribute( accessGroup: string, employeeId: string, securityRoleIds: string[ ], villageCode: string ): Promise<boolean>,

};


type TableRow = {
    
    isActive: boolean,
    expiry: string | undefined

};



export const UpdateCardholder: React.FC<UpdateCardholderProps> = ( props: UpdateCardholderProps ) => {

    const { attribute, expiry, isActive, resident, securityRoleIds, title, village, addAttribute, removeAttribute } = props;

    const [ isEnteringExpiry, setIsEnteringExpiry ] = useState<boolean>( false );
    const [ isUpdating, setIsUpdating ] = useState<boolean>( false );
    const [ row, setRow ] = useState<TableRow>( );

    const expiryRef = useRef<HTMLInputElement>( );

    let noExpiryHandling = false;
    const tomorrow: string = getTomorrow( );

    
    useEffect( ( ) => setRow( { isActive, expiry: formatExpiry( isActive, expiry ) } ), []);

    
    const formatExpiry = ( isActive: boolean, expiry: string | undefined ): string => {

        return (

            isActive
            ?
                expiry ? formatDateTime( new Date( expiry ) ) : 'No expiry'
            :
                ''

        );

    };


    const isActiveChangeHandler = async ( checked: boolean ): Promise<void> => {

        if( checked ){

            setIsEnteringExpiry( true );

        } else {

            const updatedRow = {...row};
            updatedRow.isActive = false;
            updatedRow.expiry = undefined;

            setIsUpdating( true );
            
            const isUpdateSuccessful: boolean = await removeAttribute( attribute, resident.employeeId, securityRoleIds, village.villageCode );
            
            if ( isUpdateSuccessful ) {
                
                setRow( updatedRow as TableRow );

            }

            setIsUpdating( false );
        }

    };


    const expiryChangeHandler = ( expiry: string ) => {

        const updatedRow = {...row};
        // updatedRow.expiry = new Date( expiry as string ).toLocaleDateString( "en-AU" );
        updatedRow.expiry = formatDateTime( new Date( expiry ) );
        setRow( updatedRow as TableRow );

    };


    const noExpiryClickHandler = async ( ) => {

        noExpiryHandling = true;
        
        const updatedRow = {...row};
        updatedRow.expiry = 'No expiry';
        updatedRow.isActive = true;
        setIsEnteringExpiry( false );

        // save the row to server
        setIsUpdating( true );
        
        const isUpdateSuccessful: boolean = await addAttribute( attribute, resident.employeeId, securityRoleIds, updatedRow.expiry, village.villageCode );
        
        if ( isUpdateSuccessful ) {
            setRow( updatedRow as TableRow );
        }

        setIsUpdating( false );

    };
    

    const setBlurHandler = async ( ) => {

        await sleep( 500 );
        
        const expiry = expiryRef?.current?.value as string;

        if( noExpiryHandling ) {

            noExpiryHandling = false;
            return;

        }

        const updatedRow = { ...row };
        updatedRow.isActive = true;
        
        if( expiry === tomorrow ){
            
            updatedRow.expiry = 'No expiry';

        } else {
            
            updatedRow.expiry = formatDateTime( new Date( getOneSecondBeforeMidnight( expiry ) ) );

        }

        setIsEnteringExpiry( false );

        // save the row to server
        setIsUpdating( true );
        
        
        let isUpdateSuccessful: boolean;
        
        if( expiry === tomorrow ){
        
            isUpdateSuccessful = await addAttribute( attribute, resident.employeeId, securityRoleIds, updatedRow.expiry, village.villageCode );

        } else {

            isUpdateSuccessful = await addAttribute( attribute, resident.employeeId, securityRoleIds, getOneSecondBeforeMidnight( expiry ), village.villageCode );

        }

        if ( isUpdateSuccessful ) {

            setRow( updatedRow as TableRow );
            
        }

        setIsUpdating( false );

    };

    return (

        <TableRow  sx={{ '&:last-child td, &:last-child th': { border: 0 } }} hover>
            <TableCell component="th" scope="row">{`${title}`}</TableCell>
            {
                isUpdating 
                ?
                    <TableCell colSpan={2} align='center'>
                        <CircularProgress />
                    </TableCell>
                :
                    <>
                        <TableCell >
                            {
                                row
                                ?
                                    isEnteringExpiry
                                    ?
                                    <Checkbox checked disabled/>
                                    :
                                    <Checkbox checked={row.isActive} onChange={(_, checked: boolean) => isActiveChangeHandler( checked ) }/>
                                :
                                    <Skeleton variant='text' />
                            }
                        </TableCell>
                        <TableCell>
                            {
                                row
                                ?
                                    (
                                        isEnteringExpiry
                                            ?
                                        <Stack direction="row" sx={{ alignItems: 'center', marginTop: '10px' }} spacing={ 1 }>
                                            <TextField
                                                autoFocus={ true }
                                                defaultValue={ tomorrow }
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ min: tomorrow }}
                                                inputRef={ expiryRef }
                                                label="Expiry"
                                                sx={{ width: '400px' }}
                                                type="date"
                                                onBlur={ ( )  => setBlurHandler( ) }
                                                onChange={ ( event: React.ChangeEvent<HTMLInputElement> ) => expiryChangeHandler( event.target.value ) }
                                                onKeyDown={ ( e ) => e.preventDefault( ) }
                                                
                                            />
                                    
                                            <Typography>
                                                or
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                sx={{ fontWeight: 'bold', height: '55px', textTransform: 'none', width: '160px' }}
                                                onClick={ ( ) => noExpiryClickHandler( ) }
                                            >
                                                <TimerOffIcon sx={{ mr: 1 }} />
                                                No Expiry
                                            </Button>

                                        </Stack>
                                            : 
                                        row.expiry
                                    )
                                :
                                    <Skeleton variant='text'/>
                            }
                        </TableCell>

                    </>
            }
            
        </TableRow>

    );
    
}